import { resolveDevMarket } from './devMarket';

export function isCzechMarket() {
  const host = window.location.host.toLowerCase();

  if (host.endsWith('.sk')) {
    return false;
  }

  if (host.endsWith('.cz')) {
    return true;
  }

  return resolveDevMarket() === 'cz';
}
